import React from 'react';

export default function DefaultProductImage({ iconClass }: { iconClass?: string }) {
  return (
    <svg
      width="720"
      height="720"
      viewBox="0 0 720 720"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#FFF" d="M0 0h720v720H0z" />
        <path fill="#B9C0C4" d="M360.5 111.61l114.906 96.418-4.5 5.362L356 116.972z" />
        <path fill="#B9C0C4" d="M245 208.028l114.907-96.418 4.5 5.362-114.908 96.418z" />
        <circle fill="#FFF" cx="360" cy="115" r="19" />
        <circle fill="#B9C0C4" cx="360" cy="115" r="15" />
        <path fill="#F0F3F5" d="M160 180h400v400H160z" />
        <path fill="#FFF" d="M200 220h320v320H200z" />
        <path
          d="M340.921 303l-.192 9.006c-23.801-.043-20.815-1.193-26.105 17.244l78.508-.191 3.07-8.623c-17.595-3.896-22.479-3.874-19.002-8.622h39.35l.383 8.814-10.557.191-3.071 8.431c4.87 10.82 9.025 20.027 12.571 27.871a44.69 44.69 0 0 1 14.309-2.333c24.75 0 44.815 20.028 44.815 44.735s-20.065 44.736-44.815 44.736c-21.647 0-39.709-15.32-43.9-35.69l-.831.006c-35.54-1.412-10.764 9.865-76.801-59.675-1.173 3.636-2.26 7.032-3.27 10.203 16.02 6.815 27.248 22.68 27.248 41.162 0 24.706-20.065 44.735-44.816 44.735-24.75 0-44.815-20.029-44.815-44.735 0-24.707 20.065-44.736 44.815-44.736 2.797 0 5.533.256 8.188.745 17.662-56.66 12.095-52.955 44.918-53.274zm-53.106 62.415c-19.28 0-34.911 15.603-34.911 34.85 0 19.246 15.63 34.849 34.911 34.849s34.912-15.603 34.912-34.85c0-14.056-8.337-26.169-20.345-31.68-11.346 36.075-10.312 35.32-14.822 35.776-2.507-.167-4.502-2.123-4.449-4.59.07-2.932-1.262 1.054 9.866-33.974a34.867 34.867 0 0 0-5.162-.38zm142.37-.741c-3.552 0-6.979.53-10.208 1.513 15.804 34.915 16.485 36.16 16.535 37.981-.507 6.253-3.729 4.379-40.053 4.357 3.966 14.884 17.563 25.847 33.726 25.847 19.28 0 34.911-15.602 34.911-34.849 0-19.247-15.63-34.85-34.911-34.85zm-19.051 5.641c-9.55 6.219-15.86 16.978-15.86 29.208v-.13l29.044.083zm-12.695-28.08l-21.793 57.105 8.724.025c.056-16.18 8.716-30.335 21.651-38.146l-8.582-18.984zm-9.262-3.67l-76.821.135 54.619 59.417 22.202-59.553z"
          fill="#B9C0C4" fillRule="nonzero" />
      </g>
    </svg>
  )
}
